import { FC } from "react";
import { useSelector } from "react-redux";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { Filter } from "constants/filters";
import { mapIconNameToIconSource } from "routes/reports/auditLog/IconNameMapper";
import { ITarget } from "store/entities/application-settings/interfaces";
import { selectAuditLog } from "store/entities/application-settings/selectors";

import { IFilterUpdate } from "../interfaces";
import { withFilterBase } from "../withFilterBase";

type IProps = {
  onChange(filterUpdate: IFilterUpdate<string | null>): void;
  filterValues: string;
};

const getItems = (targets: ITarget[]): IPickerListItem[] =>
  targets.map(target => ({
    key: target.name,
    name: target.labelPlural,
    icon: mapIconNameToIconSource(target.iconName),
  }));

const TargetFilter: FC<IProps> = ({ onChange, filterValues }) => {
  const handleChange = (selectedItem: IPickerListItem[] | null): void => {
    const value = selectedItem ? selectedItem[0].key : null;
    onChange({ name: Filter.Target, value });
  };
  const targets = useSelector(selectAuditLog)?.targets?.filter((target: ITarget) => target.name !== "licenses") ?? [];
  const selected = getItems(targets).find(item => item.key === filterValues);
  const filteredSelected = selected ? [selected] : [];

  return (
    <Picker
      id="target-filter"
      options={getItems(targets)}
      placeholder="Select"
      openedOnInit
      onSelect={handleChange}
      selected={filteredSelected}
    />
  );
};

export default withFilterBase(TargetFilter);
